/**
 * Generic finite-state machine driving the idle → patrol → aggro → attack
 * loop shared by all enemy types. Behavior per-state lives in the config
 * passed by each enemy (see entities/Enemy.js), this class just handles
 * transitions + lifecycle callbacks.
 */
export class EnemyStateMachine {
  /**
   * @param {object} owner - the Enemy instance this FSM drives
   * @param {Object<string, {enter?, update?, exit?}>} states
   * @param {string} initial
   */
  constructor(owner, states, initial) {
    this.owner = owner;
    this.states = states;
    this.current = null;
    this.timeInState = 0;
    this.setState(initial);
  }

  setState(name) {
    if (this.current === name) return;
    const prev = this.current;
    if (prev && this.states[prev]?.exit) {
      this.states[prev].exit.call(this.owner, this);
    }
    this.current = name;
    this.timeInState = 0;
    if (this.states[name]?.enter) {
      this.states[name].enter.call(this.owner, this);
    }
  }

  update(dt) {
    this.timeInState += dt;
    const state = this.states[this.current];
    if (state?.update) {
      state.update.call(this.owner, this, dt);
    }
  }

  is(name) {
    return this.current === name;
  }
}
